import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(LocalizedFormat)
dayjs.extend(relativeTime);

export const ageCounter: string = dayjs('20091007', 'YYYYMMDD')
	.fromNow()
	.split(' ')[0];

export const yearCounter: string = dayjs().format('YYYY');

export const dateCreated = (date: string) => {
	return dayjs(date).format('LL');
};

export const blogFormatDate = (date) => dayjs(date).format('DD MMMM YYYY');
